import { render, staticRenderFns } from "./ServiceDetailsWrapper.vue?vue&type=template&id=0df4967e&"
import script from "./ServiceDetailsWrapper.vue?vue&type=script&lang=js&"
export * from "./ServiceDetailsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports